module.exports = __webpack_public_path__ + "static/Silver Metal - Roofing-46c821c63fbdfe33e8821c1834b46130.jpg";